import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { DefaultResponseWithData } from "../models/system";
import { IVehicleCategoryPartsFilters } from "../models/Part";

export interface IVehicleCategoryRow {
  categoryId: string;
  categoryName: string;
  mechOnly: boolean;
  partOnly: boolean;
  postage: number;
  whCost: number;
  whTime: number;
  disCost: number;
  disTime: number;
  pickingTime: number;
  packingTime: number;
  notes: string | null;
  skuPrefix: string;
  ucid: string;
  ucidZone: string;
  internalStock: number;
  totalSold: number;
  /** Matching parts that were scrapped out (soft-deleted with reason Scrap). */
  totalScrapped: number;
  lastSoldDate: string | null;
  lastSoldPrice: number | null;
}

export interface IVehicleCategorySummariesResponse extends DefaultResponseWithData<IVehicleCategoryRow[]> {}

export default function useVehicleCategorySummaries(
  vehicleId: string | undefined,
  filters?: IVehicleCategoryPartsFilters
) {
  const { get, post } = useApiHelper();
  const staleTime = 1000 * 60 * 60; // 60 minutes

  const hasFilters = !!filters;

  const summaries = useQuery({
    queryKey: ["vehicleCategorySummaries", vehicleId, filters],
    queryFn: () => {
      if (!hasFilters) {
        return get<IVehicleCategorySummariesResponse>(`/part/vehicle/${vehicleId}/part-categories`);
      }

      return post<IVehicleCategoryPartsFilters, IVehicleCategorySummariesResponse>(
        `/part/vehicle/${vehicleId}/part-categories/search`,
        filters!
      );
    },
    enabled: !!vehicleId,
    staleTime: staleTime,
  });

  return {
    summaries
  };
}
